/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { Grid } from "@material-ui/core";
import styled from "styled-components";

const StyledBarChart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  .chart-item {
    font-size: 12px;
    font-weight: 600;
    padding-left: 1em;
    text-align: left;
    text-overflow: ellipsis;
  }
  .chart-counter {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid black;
  }
`;

interface BarChartProps {
  products: any;
}

const BarChart: React.FC<BarChartProps> = ({ products }) => {
  let MaxValue = 1;
  function backgroundCalculator(value: any) {
    let percentage = Math.round((value / MaxValue) * 100);

    if (percentage === 100) {
      return "rgba(17, 144, 224, 0.1)";
    } else
      return `linear-gradient(to right, rgba(17, 144, 224, 0.1) ${percentage}%, rgba(0, 0, 0, 0.1) 0%)`;
  }

  function removeDuplicates(array: any) {
    return array.filter(
      (value: any, index: number) => array.indexOf(value) === index
    );
  }

  let qtys: number[] = products?.map((e: any) =>
    Math.round(e.quantitySold)
  ) || [1];

  qtys = [...qtys, 0];

  MaxValue = Math.max(...qtys);

  qtys.sort(function (a, b) {
    return a - b;
  });

  qtys = removeDuplicates(qtys);

  return (
    <Grid item sm={6} md={3}>
      <StyledBarChart>
        {products &&
          products.length > 0 &&
          products.map((e: any, i: number) => (
            <div
              key={i}
              className="chart-item"
              style={{ background: backgroundCalculator(e.quantitySold) }}>
              <p>{e.productReport.name}</p>
            </div>
          ))}
        <div className="chart-counter">
          {qtys.map((num, index: number) => (
            <p key={index}>{num}</p>
          ))}
        </div>
      </StyledBarChart>
    </Grid>
  );
};

export default BarChart;
